import { useEffect, useState } from 'react'
import { MensajeDetalle } from '../types'
import { QueryStatus, QueryStatusType } from 'src/types'
import {HttpMessages} from "../../../http/workflow/httpMessages";

type UseMensajeResult = {
    status: QueryStatusType
    mensaje: MensajeDetalle | undefined
}

export const useMensaje: (idMensaje: number) => UseMensajeResult = idMensaje => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [mensaje, setMensaje] = useState<MensajeDetalle>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpMessages.getDetail(idMensaje)
            .then(value => {
                setMensaje(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }, [idMensaje])

    // TODO:
    //  1. crear funcion llamada api
    //  2. usecallback a la funcion
    //  3. usememo con id como dep

    return { status, mensaje }
}
